<script>
export let description = "Include a description of what the user should be trying to accomplish here."
</script>

<div
	class="editable p-4 h-full description border-r h-full text-sm"
	contenteditable="true"
	bind:innerHTML={description}
/>
